import React, { useEffect, useState } from "react";
import { CommonConfig } from "CommonConfig";
import { InputText } from "primereact/inputtext";
import api from "utils/api";
import APIConstant from "utils/constant";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import cogoToast from "cogo-toast";
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from "primereact/multiselect";

const BranchConfiguration = (props) => {
  const [userId, setUserId] = useState("");
  const [branchConfigId, setBranchConfigId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [search, setSearch] = useState("");
  const [serviceList, setServiceList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [branchConfigList, setBranchConfigList] = useState([]);
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CommonConfig.dataTableConfig.rowsPerPageOptions
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    CommonConfig.dataTableConfig.rowsPerPage
  );

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let token = localStorage.getItem("Token");
    let userPageAccess = localStorage.getItem("PageAccess");
    let lockstatus = localStorage.getItem("LockStatus");

    // if (lockstatus == 0) {
    if (token !== null) {
      setUserId(data);
      setUserPageAccess(userPageAccess);
      //   getServicesList(data);
      getBranchMaster(data);
      //   getBranchConfiguration(data);
    } else {
      props.history.push("/login");
    }
    // } else {
    //     this.props.history.push('/auth/lockscreen')
    // }
  }, []);

  const getServicesList = async (UserId, branches) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetServicesList, params)
      .then((response) => {
        if (response.Success === 1) {
          setServiceList(response.Data);
          getBranchConfiguration(UserId, response.Data, branches);
        }
      })
      .catch((err) => {});
  };

  const getBranchMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetBranchMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let tempBranches = response.Data.filter(
            (branch) => !branch.Users.includes(UserId)
          );
          setBranchList(tempBranches);
          getServicesList(UserId, tempBranches);
        }
      })
      .catch((err) => {});
  };

  const getBranchConfiguration = async (UserId, services, branches) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetBranchConfiguration, params)
      .then((response) => {
        if (response.Success === 1) {
          if (response.Data?.BranchConfigurations?.length) {
            let tempList = response.Data.BranchConfigurations;
            setBranchConfigList(
              services.map((service) => {
                let match = tempList.find(
                  (config) => config._id === service._id
                );
                if (match) {
                  return {
                    ...service,
                    Branches: branches.map((branch) => ({
                      BranchName: branch.BranchName,
                      _id: branch._id,
                      IsChecked:
                        match.Branches.find((br) => br._id === branch._id)
                          ?.IsChecked || false,
                    })),
                  };
                } else {
                  return {
                    ...service,
                    Branches: branches.map((branch) => ({
                      BranchName: branch.BranchName,
                      _id: branch._id,
                      IsChecked: false,
                    })),
                  };
                }
              })
            );
            // setBranchConfigList(response.Data.BranchConfigurations);
            setBranchConfigId(response.Data._id);
          } else {
            if (services.length) {
              setBranchConfigList(
                services.map((service) => ({
                  ...service,
                  Branches: branches.map((branch) => ({
                    BranchName: branch.BranchName,
                    _id: branch._id,
                    IsChecked: false,
                  })),
                }))
              );
            }
          }
        }
      })
      .catch((err) => {});
  };

  const addUpdateBranchConfig = async () => {
    let params = {
      BranchConfigId: branchConfigId,
      UserId: userId,
      BranchConfigurations: branchConfigList,
    };
    api
      .post(APIConstant.path.AddUpdateBranchConfiguration, params)
      .then((response) => {
        if (response.Success === 1) {
          getBranchConfiguration(userId);
          cogoToast.success(response.Message);
        } else {
          cogoToast.error(response.Message);
        }
      })
      .catch((err) => {});
  };

  const actionBodyData = (data, props) => {
    const branchOptions = branchConfigList[props.rowIndex].Branches.map(
      (branch) => ({
        label: branch.BranchName,
        value: branch.BranchName,
      })
    );

    const selectedBranches = branchConfigList[props.rowIndex].Branches.filter(
      (branch) => branch.IsChecked
    ).map((branch) => branch.BranchName);

    const handleBranchChange = (e) => {
      const updatedBranches = branchConfigList[props.rowIndex].Branches.map(
        (branch) => ({
          ...branch,
          IsChecked: e.value.includes(branch.BranchName),
        })
      );

      const tempBranchConfigList = [...branchConfigList];
      tempBranchConfigList[props.rowIndex].Branches = updatedBranches;
      setBranchConfigList(tempBranchConfigList);
    };

    return (
      <div className="p-d-flex">
        {/* {data.Branches.map((branch, idx) => (
          <div className="p-d-flex p-mr-2">
            <Checkbox
              className=""
              name={`${branch.BranchName}`}
              value={branch.IsChecked}
              checked={branch.IsChecked}
              onChange={(e) => {
                let tempBranchConfigList = [...branchConfigList];
                tempBranchConfigList[props.rowIndex].Branches[idx].IsChecked =
                  e.target.checked;
                setBranchConfigList(tempBranchConfigList);
              }}
            />
            <div>{branch.BranchName}</div>
          </div>
        ))} */}

        <div className="custom-inputs e-order-mng p-mt-3">
          <MultiSelect
            value={selectedBranches}
            options={branchOptions}
            onChange={handleBranchChange}
            placeholder="Select Branches"
            display="chip"
            className="p-w-100"
          />
        </div>
      </div>
    );
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-cog"></i>
          <h2>Branch Configuration</h2>
        </div>
        <div className="heading-area-right p-d-lg-flex p-ai-center ">
          <div className="searchbar-area p-as-center">
            <InputText
              type="search"
              onInput={(e) => setSearch(e.target.value)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 10 }}
            />
            <i className="icon-search"></i>
          </div>
          <div>
            <div className="e-add-btn" onClick={(e) => addUpdateBranchConfig()}>
              Submit
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="main-access-card-master e-card-master">
        <DataTable
          className="main-table table-td e-company-table"
          // style={{ height: "calc(100vh - 196px)" }}
          value={branchConfigList}
          editMode="row"
          dataKey="id"
          responsiveLayout="scroll"
          paginator={true}
          rows={rowsPerPage}
          totalRecords={branchConfigList.length}
          rowsPerPageOptions={rowsPerPageOptions}
          globalFilter={search}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column
            field="ServiceName"
            header="Service"
            style={{ width: "15%" }}
          ></Column>
          <Column
            field="BranchName"
            header="Branch Name"
            style={{ width: "15%" }}
            body={actionBodyData}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default BranchConfiguration;
